import { Module } from 'vuex';

import { BasicResult, RootState } from 'frontend/types';

const basicResult: Module<BasicResult, RootState> = {
  namespaced: true,
  state: {} as BasicResult,
  mutations: {
    setValue(state: BasicResult, value: BasicResult) {
      Object.assign(state, value);
    },
  },
};

export default basicResult;
